import React, { useState } from 'react'
import "./Contact.css";
import { RiSendPlaneFill } from "react-icons/ri";
import Fade from 'react-reveal/Slide';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Contact() {


   const API = "http://localhost:8080/sendEmail";

   const [name, setName] = useState();
   const [email, setEmail] = useState()
   const [jopType, setJopType] = useState()
   const [message, setMessage] = useState()


   const sendEmail = () => {
    fetch(API, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
        },
        body: JSON.stringify({
            name,
            email,
            jopType,
            message,
        })
    }).then((res)=> res.json())
    .then((result) => {
        if(result.error){
             toast.error(result.error, {
                position: toast.POSITION.TOP_RIGHT,
                
            })
        }else{

            toast.success("your emial has been sent", {
                position: toast.POSITION.TOP_RIGHT,
                
            })
            setName("");
            setEmail("");
            setJopType("");
            setMessage("");
        }
       
    })
    .catch((error) => console.log(error));
   };


    return (
        <div id='contactid' className='container contact-section'>
            <div className="con">
                <div className="row">

                 <Fade bottom>
                 <div className="col-xl-5 col-lg-5 col-md-5 col-sm-5">
                      
                      <div className="contact-from-image">
                          <img src='https://images.unsplash.com/photo-1588865876768-f9e265a1d38f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1034&q=80' alt='contact image' />
                      </div>
                  

              </div>
                 </Fade>
                    <Fade right>
                        <div className="col-xl-7 col-lg-7 col-md-7 col-sm-7">
                            <div className="contact-from-design">
                                <div className="text-center">
                                    <h5>Contact Us</h5>
                                    <form>
                                        <div className="contact-form">
                                            <label className='form-lebel'>Name</label>
                                            <input type="text" className='form-control'  value={name} onChange={(e)=>setName(e.target.value)}/>
                                        </div>

                                        <div className="contact-form">
                                            <label className='form-lebel'>E-mail</label>
                                            <input type="text" className='form-control' value={email} onChange={(e)=>setEmail(e.target.value)}/>
                                        </div>

                                        <div className="contact-form">
                                            <label className='form-lebel'>Job Types</label>
                                            <select className='custom-select-tage' value={jopType} onChange={(e)=>setJopType(e.target.value)}>
                                                <option>Full Time</option>
                                                <option>Working Student</option>
                                                <option>Part Time</option>
                                                <option>Contruct</option>
                                            </select>
                                        </div>

                                        <div className="contact-form">
                                            <label className='form-lebel'>Your Message</label>
                                            <textarea rows="4" type="text" className='form-control' value={message} onChange={(e)=>setMessage(e.target.value)}/>
                                        </div>

                                        <div className="button-submit" onClick={sendEmail}>
                                            <p>Send<RiSendPlaneFill size={20} /></p>
                                        </div>

                                    </form>
                                </div>
                            </div>
                        </div>
                    </Fade>
                </div>
            </div>
            <ToastContainer draggable={true} hideProgressBar={false} autoClose={8000}/>
        </div>
    )
}

export default Contact